import { takeEvery, call, put } from 'redux-saga/effects';
import {
  dataRequest,
  requestFinished,
  insertUpdateItems as insertUpdateObjectCollectionItems
} from '../../../../../../common/reducers/objectCollection/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import UserService from '../../../../services/UserService';

function* userGetByIdSaga(reducerName, action) {
  try {
    const result = yield call(
      timeoutCall,
      UserService.getUserInfo,
      action.payload.objectId
    );
    if (result.response) {
      if (result.response.status) {
        yield put(
          insertUpdateObjectCollectionItems(
            reducerName,
            result.destructData.userModel
          )
        );
        yield put(
          insertUpdateObjectCollectionItems(
            'userBlackList.collections.userBlackListCollection',
            result.destructData.outOfMyBlackListCustomerModel
          )
        );
        yield put(
          insertUpdateObjectCollectionItems(
            'userBlackList.collections.userBlackListCollection',
            result.destructData.outOfMyBlackListExecutor
          )
        );
      }
    }
    yield put(
      requestFinished(
        reducerName,
        action.payload.objectId,
        result.response.status
      )
    );
  } catch (error) {
    yield put(requestFinished(reducerName, action.payload.objectId));
  }
}

export default function createSaga(reducerName) {
  return [
    takeEvery(dataRequest(reducerName).type, userGetByIdSaga, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/reducers/static/collections/sagas/userGetByIdSaga.js